// Spotify iframe configuration
const SPOTIFY_IFRAME_CONFIG = {
  height: 152,
  margin: 16,
  theme: 0
};

window.onSpotifyIframeApiReady = (IFrameAPI) => {
  
  const element = document.getElementById('embed-iframe');
  // Get the Spotify URI from the hidden input
  const spotifyInput = document.getElementById('spotify_uri');
  const spotifyUri = spotifyInput ? spotifyInput.getAttribute('data-uri') : '';

  if (!element || !spotifyUri) {
    return;
  }

  const options = {
      uri: spotifyUri,
      height: SPOTIFY_IFRAME_CONFIG.height.toString(),
      theme: SPOTIFY_IFRAME_CONFIG.theme
    };
  const callback = (EmbedController) => {
      document.querySelectorAll('.playlist').forEach(
        playlist => {
          playlist.addEventListener('click', function (e) {
            const playIcon = this.querySelector('.icon-play');
            const pauseIcon = this.querySelector('.icon-pause');
            const container = this.closest('.image-container');
            const video = container.querySelector('video');
            // Before playing, reset all other buttons to play state
            document.querySelectorAll('.playlist').forEach(btn => {
              if (btn !== this) {
                const btnPlayIcon = btn.querySelector('.icon-play');
                const btnPauseIcon = btn.querySelector('.icon-pause');
                const btnContainer = btn.closest('.image-container');
                const btnVideo = btnContainer ? btnContainer.querySelector('video') : null;
                
                if (btnPlayIcon && btnPauseIcon) {
                  btnPlayIcon.style.display = '';
                  btnPauseIcon.style.display = 'none';
                }
                
                // Pause other videos
                if (btnVideo && !btnVideo.paused) {
                  btnVideo.pause();
                  btnVideo.currentTime = 0; // Restart video to beginning
                }
              }
            });
            // If currently showing play icon, play and swap to pause
            if (playIcon && pauseIcon && playIcon.style.display !== 'none') {
              EmbedController.loadUri(this.dataset.spotifyId);
              if (typeof EmbedController.play === 'function') {
                setTimeout(() => {
                  EmbedController.play();
                  video.play();
                  playIcon.style.display = 'none';
                  pauseIcon.style.display = '';
                }, 300);
              }
            }
            // If currently showing pause icon, pause and swap to play
            else if (playIcon && pauseIcon && pauseIcon.style.display !== 'none') {
              if (typeof EmbedController.pause === 'function') {
                EmbedController.pause();
                video.pause();
                video.currentTime = 0; // Restart video to beginning
                playIcon.style.display = '';
                pauseIcon.style.display = 'none';
              }
            }
          });
        });
  };
  IFrameAPI.createController(element, options, callback);
};

// Function to handle iframe positioning based on scroll position
function handleIframePosition() {
  if (window.innerWidth >= 1024) {
    const iframe = document.querySelector('.multicollumn-text-section iframe');
    if (iframe) {
      const targetSection = document.querySelector('.multicollumn-text-section');
      
      if (targetSection) {
        const sectionTop = targetSection.offsetTop;
        const windowHeight = window.innerHeight;
        const scrollY = window.scrollY;

        // Appears when the section starts entering the viewport from below
        const triggerPoint = sectionTop - windowHeight;
        if (scrollY > triggerPoint) {
          iframe.style.display = 'block';
          iframe.style.top = 'auto';
          iframe.style.bottom = SPOTIFY_IFRAME_CONFIG.margin + 'px';
        } else {
          iframe.style.display = 'none';
        }
      } else {
        // Fallback to previous behavior if section is not found
        if (window.scrollY > 400) {
          iframe.style.display = 'block';
          iframe.style.top = 'auto';
          iframe.style.bottom = SPOTIFY_IFRAME_CONFIG.margin + 'px';
        } else {
          iframe.style.display = 'none';
        }
      }
    }
  }
}

// Force initialization of iframe on every page load
function initializeIframe() {
  if (window.innerWidth >= 1024) {
    // Add timeout to ensure iframe is fully loaded
    setTimeout(() => {
      const iframe = document.querySelector('.multicollumn-text-section iframe');
      if (iframe) {
        // Force reset iframe to initial state
        iframe.style.display = 'none';
        iframe.style.position = 'fixed';
        iframe.style.right = SPOTIFY_IFRAME_CONFIG.margin + 'px';
        iframe.style.top = 'auto';
        iframe.style.bottom = 'auto';
        
        // Run the position handler to set correct state based on current scroll
        handleIframePosition();
      }
    }, 500); // Wait 500ms for iframe to be ready
  }
}

window.addEventListener('scroll', handleIframePosition);

// Force initialization on both load events
window.addEventListener('load', () => {
  initializeIframe();
});

document.addEventListener('DOMContentLoaded', () => {
  initializeIframe();
});

// Also run on beforeunload to ensure clean state for next load
window.addEventListener('beforeunload', () => {
  const iframe = document.querySelector('.multicollumn-text-section iframe');
  if (iframe) {
    iframe.style.display = 'none';
  }
});

// Variables to store the state of applied filters

var lastAppliedYears = [];
  
document.addEventListener('DOMContentLoaded', function() {

  if (!window.__playlistsFacetsLoaded) {
  window.__playlistsFacetsLoaded = true;

    var openBtns = document.querySelectorAll('.mobile-facets__open');
    var blurOverlay = document.querySelector('.playlists-blur');

    openBtns.forEach(function(openBtn) {
      openBtn.addEventListener('click', function() {
        var playlistsContainer = openBtn.closest('.playlists');
        if (!playlistsContainer) return;
        var isOpen = playlistsContainer.classList.contains('open');
        if (!isOpen) {
          openPlaylistsModal(playlistsContainer);
        } else {
          closePlaylistsModal(playlistsContainer, true);
        }
      });
    });
    

    // Optional: close on outside click
    document.addEventListener('click', function(e) {
      document.querySelectorAll('.playlists.open').forEach(function(playlistsContainer) {
        var filterContainer = playlistsContainer.querySelector('.playlists-filter-container');
        var openBtn = playlistsContainer.querySelector('.mobile-facets__open');
        // Removed the 'open' class check on filterContainer
        if (
          filterContainer &&
          !filterContainer.contains(e.target) &&
          !openBtn.contains(e.target)
        ) {
          closePlaylistsModal(playlistsContainer, true);
        }
      });
    });

  

    function updateFooterVisibility() {
      var footer = document.querySelector('.mobile-facets__footer');
      var activeFilters = document.querySelector('.playlists-filter-container .active');
      if (footer) {
        footer.style.display = activeFilters ? '' : 'none';
      }
    }

    // Centralized function to apply filters
    function applyFilters(applyAndClose) {
      // Update button counts
      var activeYears = Array.from(document.querySelectorAll('.playlists-filter-year.active')).map(function(el) {
        return el.getAttribute('data-year');
      }).filter(Boolean);
      var shownCount = 0;
      // Calculate how many items would be shown with the current filters
      document.querySelectorAll('.playlists-list__grid').forEach(function(grid) {
        var year = grid.querySelector('.playlist-year[data-year]')?.getAttribute('data-year');
        var yearMatch = !activeYears.length || (year && activeYears.includes(year));
        if (yearMatch) {
          shownCount++;
        }
      });
      var applyBtn = document.querySelector('.apply-filters-button');
      var removeBtn = document.querySelector('.remove-filters-button');
      if (applyBtn) {
        if (activeYears.length) {
          const applyBtnHTML = (applyBtn.dataset.baseLabel || applyBtn.textContent) + ' (' + shownCount + ')';
          applyBtn.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(applyBtnHTML) : applyBtnHTML;
        } else {
          const applyBtnHTML = applyBtn.dataset.baseLabel || applyBtn.textContent;
          applyBtn.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(applyBtnHTML) : applyBtnHTML;
        }
      }
      if (removeBtn) {
        var activeCount = activeYears.length;
        if (!removeBtn.dataset.baseLabel) {
          removeBtn.dataset.baseLabel = removeBtn.textContent.trim();
        }
        if (activeCount > 0) {
          const removeBtnHTML = removeBtn.dataset.baseLabel + ' (' + activeCount + ')';
          removeBtn.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(removeBtnHTML) : removeBtnHTML;
        } else {
          const removeBtnHTML = removeBtn.dataset.baseLabel;
          removeBtn.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(removeBtnHTML) : removeBtnHTML;
        }
      }
      // Update active filter count
      var count = document.querySelectorAll('.playlists-filter-year.active').length;
      var countSpan = document.querySelector('.playlists-filter-active-count');
      if (countSpan) {
        countSpan.textContent = count > 0 ? '(' + count + ')' : '';
      }
      // If applying and closing
      if (applyAndClose) {
        // Filter the list
        var filtered = [];
        document.querySelectorAll('.playlists-list__grid').forEach(function(grid) {
          var year = grid.querySelector('.playlist-year[data-year]')?.getAttribute('data-year');
          var yearMatch = !activeYears.length || (year && activeYears.includes(year));
          if (yearMatch) {
            grid.style.display = '';
            filtered.push(grid);
          } else {
            grid.style.display = 'none';
            grid.classList.add('hidden');
          }
        });

        // Show all if <= 4, otherwise show 4 and hide the rest
        filtered.forEach(function(grid, idx) {
          if (filtered.length <= 4) {
            grid.classList.remove('hidden');
          } else {
            if (idx < 4) {
              grid.classList.remove('hidden');
            } else {
              grid.classList.add('hidden');
            }
          }
        });

        lastAppliedYears = [...activeYears];
        // Close the modal
        var playlistsContainer = applyBtn ? applyBtn.closest('.playlists') : null;
        closePlaylistsModal(playlistsContainer, false);

        // Update Load More button after filtering
        updateLoadMoreButton();
      }
      // Update filter availability
      updateFilterAvailability();
      updateFooterVisibility();
    }

    function updateFilterAvailability() {
      // Get all possible type/year combinations from visible playlists
      var visibleYears = new Set();
      var activeYears = Array.from(document.querySelectorAll('.playlists-filter-year.active')).map(el => el.getAttribute('data-year'));

      // If a type is selected, only consider playlists with that type; same for year
      document.querySelectorAll('.playlists-list__grid').forEach(function(grid) {
        var year = grid.querySelector('.playlist-year[data-year]')?.getAttribute('data-year');
        var yearMatch = !activeYears.length || (year && activeYears.includes(year));
        if (yearMatch) {
          if (year) visibleYears.add(year);
        }
      });
    }

    // Store base label for apply and remove buttons
    var applyBtn = document.querySelector('.apply-filters-button');
    if (applyBtn) {
      applyBtn.dataset.baseLabel = applyBtn.textContent.trim();
    }
    var removeBtn = document.querySelector('.remove-filters-button');
    if (removeBtn) {
      removeBtn.dataset.baseLabel = removeBtn.textContent.trim();
      removeBtn.addEventListener('click', function() {
        document.querySelectorAll('.playlists-filter-year.active').forEach(function(item) {
          item.classList.remove('active');
        });
        applyFilters(true);
      });
    }


    // Apply button closes the filters container
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        applyFilters(true);
      });
    }

    document.querySelectorAll('.playlists-filter-year').forEach(function(item) {
      item.addEventListener('click', function(e) {
        if (item.classList.contains('disabled')) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        e.stopPropagation();
        item.classList.toggle('active');
        applyFilters(false);
      });
    });

    // Initial state
    applyFilters(false);

    if (!window.__playlistsScriptLoaded) {
      window.__playlistsScriptLoaded = true;
      // Custom sort dropdown logic with sorting functionality
      (function() {
        var sortDropdowns = document.querySelectorAll('.playlists .custom-sort-dropdown');

        if (!sortDropdowns.length) return;
        var playlistsList = document.querySelector('.playlists-list');
        var playlistGrids = Array.from(document.querySelectorAll('.playlists-list__grid'));

        sortDropdowns.forEach(function(sortDropdown) {
          var list = sortDropdown.querySelector('.custom-sort-list');
          var items = list.querySelectorAll('li');

          function closeDropdown() {
            list.style.display = 'none';
            sortDropdown.classList.remove('open');
          }

          // Toggle dropdown on click
          sortDropdown.addEventListener('click', function(e) {
            // Only toggle if not clicking on a list item
            if (!e.target.closest('li')) {
              e.stopPropagation();
              if (list.style.display === 'block') {
                list.style.display = 'none';
                sortDropdown.classList.remove('open');
              } else {
                list.style.display = 'block';
                sortDropdown.classList.add('open');
              }
            }
          });

          // Handle item click
          items.forEach(function(item) {
            item.addEventListener('click', function(e) {
              e.stopPropagation();
              items.forEach(function(i) { i.classList.remove('active'); });
              item.classList.add('active');
              closeDropdown();
              sortPlaylists(item.getAttribute('data-sort'));
            });
          });
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function() {
          sortDropdowns.forEach(function(sortDropdown) {
            var list = sortDropdown.querySelector('.custom-sort-list');
            if (list) {
              list.style.display = 'none';
              sortDropdown.classList.remove('open');
            }
          });
        });

        window.sortPlaylists = function(sortType) {
          var visibleGrids = playlistGrids.filter(function(grid) {
            return grid.style.display !== 'none';
          });
        
          var sorted = visibleGrids.slice();
        
          if (sortType === 'year-asc' || sortType === 'year-desc') {
            sorted.sort(function(a, b) {
              var fullDateA = a.querySelector('.playlist-full-date[data-full-date]')?.getAttribute('data-full-date') || '0000-00';
              var fullDateB = b.querySelector('.playlist-full-date[data-full-date]')?.getAttribute('data-full-date') || '0000-00';
              
              // Convert to comparable format (YYYY-MM becomes YYYYMM as number)
              var dateNumA = parseInt(fullDateA.replace('-', ''), 10);
              var dateNumB = parseInt(fullDateB.replace('-', ''), 10);
              
              if (isNaN(dateNumA)) dateNumA = 0;
              if (isNaN(dateNumB)) dateNumB = 0;
              
              return sortType === 'year-asc' ? dateNumA - dateNumB : dateNumB - dateNumA;
            });
          } else if (sortType === 'az' || sortType === 'za') {
            sorted.sort(function(a, b) {
              var titleAEl = a.querySelector('.playlist-card__title');
              var titleBEl = b.querySelector('.playlist-card__title');
              var titleA = titleAEl ? titleAEl.textContent.trim().toLowerCase() : '';
              var titleB = titleBEl ? titleBEl.textContent.trim().toLowerCase() : '';
              if (titleA < titleB) return sortType === 'az' ? -1 : 1;
              if (titleA > titleB) return sortType === 'az' ? 1 : -1;
              return 0;
            });
          }
        
          sorted.forEach(function(grid) {
            if (grid.parentNode) {
              grid.parentNode.appendChild(grid);
            }
          });
        }
      })();
    }

    // Add event listener to close icon in filter modal
    document.querySelectorAll('.playlists-filter-container .icon-close').forEach(function(closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        var playlistsContainer = closeBtn.closest('.playlists');
        // fallback: if not found, try parentNode
        if (!playlistsContainer) playlistsContainer = document.querySelector('.playlists');
        closePlaylistsModal(playlistsContainer, true);
      });
    });

    // Utility function to close the filter modal
    function closePlaylistsModal(playlistsContainer, restoreFilters = false) {
      if (!playlistsContainer) return;

      var playlistsFilters = document.querySelector('.playlists-filters');
      if (playlistsFilters) {
        playlistsFilters.classList.add('header-transition')
      }
      playlistsContainer.classList.remove('open');
      document.body.style.overflow = '';
      if (blurOverlay) blurOverlay.classList.remove('active');
      
      // Show the filter button when modal is closed
      var playlistsFilters = document.querySelector('.playlists-filters');
      if (playlistsFilters) {
        playlistsFilters.style.visibility = 'visible';
      }
      
      // Remove open class from list-playlist-section
      var listPlaylistSection = document.querySelector('.list-playlist-section');
      if (listPlaylistSection) {
        listPlaylistSection.classList.remove('open');
      }
      
      if (typeof iconPlus !== 'undefined' && typeof iconMinus !== 'undefined') {
        iconPlus.style.display = '';
        iconMinus.style.display = 'none';
      }
      // If restoreFilters is true, visually restore filters to the last applied state
      if (restoreFilters) {
        // Remove all active filters
        document.querySelectorAll('.playlists-filter-year.active').forEach(function(item) {
          item.classList.remove('active');
        });
        
        // Activate saved years
        lastAppliedYears.forEach(function(year) {
          var el = document.querySelector('.playlists-filter-year[data-year="' + year + '"]');
          if (el) el.classList.add('active');
        });
        // Update disabled state and UI of buttons/counters
        updateFilterAvailability();
        applyFilters(false);
      }
    }

    // Utility function to open the filter modal
    function openPlaylistsModal(playlistsContainer) {
      if (!playlistsContainer) return;
      
      var playlistsFilters = document.querySelector('.playlists-filters');
      if (playlistsFilters) {
        playlistsFilters.classList.remove('header-transition')
        playlistsFilters.style.visibility = 'hidden';
      }
      // Open the modal immediately
      playlistsContainer.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (blurOverlay) blurOverlay.classList.add('active');
      
      
      // Calculate positioning and set immediately without animation
      var playlistsFilterContainer = document.querySelector('.playlists-filter-container');
      var listPlaylistSection = document.querySelector('.list-playlist-section');
      
      if (playlistsFilters && playlistsFilterContainer) {
        var viewportHeight = window.innerHeight;
        var filtersRect = playlistsFilters.getBoundingClientRect();
        var containerRect = playlistsFilterContainer.getBoundingClientRect();
        
        // Calculate all distances and values
        var distanceFromTop = filtersRect.top;
        var distanceToViewportBottom = viewportHeight - filtersRect.bottom;
        var containerHeight = containerRect.height;
        var needsScroll = distanceToViewportBottom < containerHeight;
        var scrollDifference = needsScroll ? containerHeight - distanceToViewportBottom + 40 : 0;
        
        // Calculate the final top position accounting for scroll
        var finalTopPosition = needsScroll ? distanceFromTop - scrollDifference : distanceFromTop;

        // Set the overlay clip-path to only show below the filter container
        var filterBottom = finalTopPosition + containerHeight;
        document.documentElement.style.setProperty('--filter-bottom', filterBottom + 'px');
        
        // Apply positioning immediately without transition
        playlistsFilterContainer.style.top = finalTopPosition + 'px';
        
        // Scroll if needed (can keep smooth scroll for page)
        if (needsScroll && scrollDifference > 0) {
          window.scrollBy({ 
            top: scrollDifference, 
            behavior: 'smooth' 
          });
        }
        
        // Add open class to list-playlist-section immediately
        if (listPlaylistSection) {
          listPlaylistSection.classList.add('open');
        }
      }
    }

    // Add this function after applyFilters
    function updateLoadMoreButton() {
      var loadMoreBtn = document.getElementById('load-more-playlists');
      var playlistList = document.getElementById('playlist-list');
      if (!playlistList || !loadMoreBtn) return;
      // Only consider cards that are not display:none (filtered in)
      var filteredCards = Array.from(playlistList.querySelectorAll('.playlist-card')).filter(function(card) {
        return card.style.display !== 'none';
      });
      var visibleCards = filteredCards.filter(function(card) {
        return !card.classList.contains('hidden');
      });
      var hiddenCards = filteredCards.filter(function(card) {
        return card.classList.contains('hidden');
      });
      // Update button count to reflect total filtered playlists
      const loadMoreBtnHTML = loadMoreBtn.innerHTML.replace(/\(\d+\)/, '(' + filteredCards.length + ')');
      loadMoreBtn.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(loadMoreBtnHTML) : loadMoreBtnHTML;
      // Hide if all filtered cards are visible or there are no hidden filtered cards
      if (hiddenCards.length === 0 || visibleCards.length >= filteredCards.length) {
        loadMoreBtn.style.display = 'none';
      } else {
        loadMoreBtn.style.display = '';
      }
    }

    // Update the load more click handler to only show visible playlists
    var loadMoreBtn = document.getElementById('load-more-playlists');
    var playlistList = document.getElementById('playlist-list');
    if (playlistList && loadMoreBtn) {
      var showCount = 4;
      loadMoreBtn.addEventListener('click', function() {
        var hiddenCards = playlistList.querySelectorAll('.playlist-card.hidden');
        for (var i = 0; i < showCount && i < hiddenCards.length; i++) {
          hiddenCards[i].classList.remove('hidden');
        }
        // Hide button if no more hidden cards
    if (playlistList.querySelectorAll('.playlist-card.hidden').length === 0) {
          loadMoreBtn.style.display = 'none';
        }
      });
    }

    // 👇 Ajoute ce bloc ici
    if (window.sortPlaylists) {
      window.sortPlaylists('year-desc'); // tri par défaut en ordre décroissant
    }
  }
});
